import CardSection from './CardSection';
import InputField from '../form/InputField';

export default function AditionalVehicleInfoSection({
    data, 
    onChange, 
    errors 
}) {
    // Fecha de hoy en formato YYYY-MM-DD, para usar como mínimo en fechas
    const today = new Date().toISOString().split('T')[0];

    return (
        <>
            <CardSection icon="gps_fixed" title="Datos del GPS">
                <div className="row">
                    <div className="col-md-4">
                        <InputField
                            id="gpsUsuario"
                            label="Usuario GPS"
                            placeholder="Ingrese usuario del GPS"
                            value={data.gpsUsuario || ''}
                            onChange={onChange}
                            error={errors?.gpsUsuario}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="gpsContrasena"
                            label="Contraseña GPS"
                            type="password"
                            placeholder="Ingrese contraseña"
                            value={data.gpsContrasena || ''}
                            onChange={onChange}
                            error={errors?.gpsContrasena}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="gpsUrl"
                            label="URL del GPS"
                            placeholder="Ingrese URL"
                            value={data.gpsUrl || ''}
                            onChange={onChange}
                            error={errors?.gpsUrl}
                        />
                    </div>
                </div>
            </CardSection>

            <CardSection icon="description" title="Datos de Leasing">
                <div className="row">
                    <div className="col-md-4">
                        <InputField
                            id="leasingNumeroContrato"
                            label="Número de Contrato"
                            placeholder="Ingrese número de contrato"
                            value={data.leasingNumeroContrato || ''}
                            onChange={onChange}
                            error={errors?.leasingNumeroContrato}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="leasingFechaInicio"
                            label="Fecha de Inicio"
                            type="date"
                            value={data.leasingFechaInicio || ''}
                            onChange={onChange}
                            onKeyDown={e => e.preventDefault()}
                            onPaste={e => e.preventDefault()}
                            error={errors?.leasingFechaInicio}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="leasingFechaVencimiento"
                            label="Fecha de Vencimiento"
                            type="date"
                            value={data.leasingFechaVencimiento || ''}
                            onChange={onChange}
                            min={today}
                            onKeyDown={e => e.preventDefault()}
                            onPaste={e => e.preventDefault()}
                            error={errors?.leasingFechaVencimiento}
                        />
                    </div>
                </div>
            </CardSection>

            <CardSection icon="security" title="Póliza de Daños a Terceros">
                <div className="row">
                    <div className="col-md-4">
                        <InputField
                            id="polizaNitCompania"
                            label="NIT Compañía de Seguros"
                            placeholder="Ingrese NIT"
                            value={data.polizaNitCompania || ''}
                            onChange={onChange}
                            error={errors?.polizaNitCompania}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="polizaNumero"
                            label="Número de Póliza"
                            placeholder="Ingrese número de póliza"
                            value={data.polizaNumero || ''}
                            onChange={onChange}
                            error={errors?.polizaNumero}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="polizaFechaVencimiento"
                            label="Fecha de Vencimiento"
                            type="date"
                            value={data.polizaFechaVencimiento || ''}
                            onChange={onChange}
                            min={today}
                            onKeyDown={e => e.preventDefault()}
                            onPaste={e => e.preventDefault()}
                            error={errors?.polizaFechaVencimiento}
                        />
                    </div>
                </div>
            </CardSection>
        </>
    );
}
